import { FONT_FAMILY } from "../../../../core/common/constants/styles.constants";

export const graphOptions: any = {
  data: [{
    name: 'Normal',
    x: [],
    y: [],
    mode: 'lines',
    // marker: {
    //   //color: 'rgb(255, 217, 102)',
    //   // size: .5
    // },
    // line: {
    //   width: 1
    // },
    type: 'scattergl',
  },
  ],
  layout: {
    font: { ...FONT_FAMILY },
    autosize: true,
    hoverinfo: 'none',
    margin: {
      t: 20,
      b: 5,
      l: 60,
      r: 10,
      pad: 5
    },
    legend: {
      "orientation": "h",
      // x: 0,
      // y: 1
      font: {
        size: 10,
        color: '#000'
      }
    },
    yaxis:{
      automargin: true,
    },
    xaxis: {
      automargin: true,
    },
    barcornerradius: 8,
    spikedistance: 20
  }
};

export const heatmapLayout = {
  font: { ...FONT_FAMILY },
  datarevision: 0,
  hovermode: 'closest',
  bgcolor: 'rgb(0,0,0)',
  // height: 400,
  margin: {
    t: 20,
    b: 40,
    l: 40,
    r: 20,
    pad: 1
  },
  autosize: true,
  xaxis: {
      ticks: '',
      side: 'bottom',
      autosize: false
  },
  yaxis: {
    showticklabels: false,
    //automargin: true,
    title: { text: 'Tags' },
    ticks: '',
    side: 'left',
    ticksuffix: ' ',
    type: 'category',
    autosize: false
  }
}

export const echartOptions:any = {
  textStyle: {
    fontFamily: FONT_FAMILY.family,
  },
  backgroundColor: '#FFFFFF',
  tooltip:{
    trigger: 'item',
    confine: true,
    backgroundColor: '#252525',
    borderColor: '#252525',
    textStyle: {
        color: '#FFFFFF'
    },
    extraCssText: 'border-radius: 13px'
  },
  data: [],
  legend: {
    show : true,
    itemWidth: 8,
    itemHeight: 8,
    itemgap : 15,
    textStyle: {
        color: '#9291A5',
        fontSize: 10
    },
    backgroundColor : '#FFFFFF',
    data: [],
  },
  dataZoom: [
    {
        type: 'slider',
        xAxisIndex: 0
    },
    {
        type: 'inside',
        xAxisIndex: 0
    },
    {
        type: 'slider',
        yAxisIndex: 0,
        orient: 'vertical'
    },
    {
        type: 'inside',
        yAxisIndex: 0,
    }
],
  series: [{
    data : []
  }],
  responsive: true
}